const DEFAULT_URL_BASE = 'https://t.me';

export function sanitizeReferralLink(value: unknown): string {
  if (typeof value !== 'string') {
    return '';
  }

  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return '';
  }

  try {
    const url = new URL(trimmedValue);
    url.searchParams.delete('write_access');
    return url.toString();
  } catch {
    try {
      const url = new URL(trimmedValue, DEFAULT_URL_BASE);
      url.searchParams.delete('write_access');
      return url.toString();
    } catch {
      return trimmedValue.replace(/([?&])write_access=[^&#]*(&?)/gi, (_match, prefix: string, suffix: string) => {
        if (prefix === '?' && suffix) {
          return '?';
        }

        return prefix === '?' ? '' : suffix ? prefix : '';
      });
    }
  }
}
